import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';

import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  auth = inject(AuthService);
  router = inject(Router);
  platformId = inject(PLATFORM_ID);

  canActivate(): Observable<boolean> {
    return this.canAccessRoute();
  }

  canActivateChild(): Observable<boolean> {
    return this.canAccessRoute();
  }

  canMatch(): Observable<boolean> {
    return this.canAccessRoute();
  }

  private canAccessRoute(): Observable<boolean> {
    if (this.auth.isLoggedIn) {
      return this.auth.checkToken();
    }
    if (isPlatformBrowser(this.platformId)) {
      this.router.navigateByUrl('/auth/login').then();
    }
    return of(false);
  }
}
